import { Link } from 'react-router-dom'
import { Icons } from '@/components/homepage/ui/Icons'
import { DocsSearch } from './DocsSearch'

export function DocsNavbar() {
  return (
    <header className="sticky top-0 z-40 bg-background border-b border-border/40">
      <div className="max-w-[1400px] mx-auto flex items-center h-16 px-6 lg:px-10 gap-6">
        <Link to="/docs" className="shrink-0">
          <Icons.logo />
        </Link>

        <div className="flex-1 flex justify-center">
          <div className="w-full max-w-md">
            <DocsSearch />
          </div>
        </div>

        <Link
          to="/login"
          className="bg-sky-500 hover:bg-sky-600 text-white text-[13px] font-medium px-5 py-2 rounded-full transition-colors shrink-0"
        >
          Go to app
        </Link>
      </div>
    </header>
  )
}
